import {GetSeferData} from "SeferPetach/GetData";

export async function getUserList(obj) {
    var args = obj;
    var payload = await GetSeferData("glusr", args);
    return (payload);
}
export async function getUserListBond() {
    var args = {};
    var payload = await GetSeferData("glusrb", args);
    return (payload);
}
export async function bondOperation(list) {
    const args = list;
    var payload = await GetSeferData("mmup", args);
    return (payload);
}

export async function getUserByID(user_data){
    const args = {
        UserId: user_data.UserId,
    };
    var payload = await GetSeferData("gusr", args);
    return (payload);
}

export async function updateUser(obj) {
    const args = {
        UserId                  :   obj.UserId,
        Email                   :   obj.Email,
        FirstName               :   obj.FirstName,
        LastName                :   obj.LastName,
        ModuleName              :   obj.ModuleName,
    };
    var payload = await GetSeferData("uhausr", args);
    return (payload);
}